import { Helmet } from "react-helmet";
import PropTypes from "prop-types";

export const SITE_URL = "https://irangardi.app";
export const SITE_NAME = "ایرانگردی";
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

/** absolute URL for a path ("/blogs") or an already absolute URL */
export const absoluteUrl = (value) => (/^https?:\/\//i.test(value || "") ? value : `${SITE_URL}${value || "/"}`);

/**
 * One place for everything a page tells search engines / link previews:
 * title, description, canonical, robots, Open Graph, Twitter card and JSON-LD blocks.
 *
 *  <Seo title="..." description="..." path="/blogs" image={url} jsonLd={[{...}]} noindex />
 */
const Seo = ({ title, description, path, image, type = "website", noindex = false, jsonLd = [] }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | معرفی جاذبه‌ها و راهنمای سفر در طبیعت ایران`;
  const canonical = path ? absoluteUrl(path) : undefined;
  const ogImage = image ? absoluteUrl(image) : DEFAULT_IMAGE;
  const blocks = (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).filter(Boolean);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="fa_IR" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title || fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />

      {blocks.map((data, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
};

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  path: PropTypes.string,
  image: PropTypes.string,
  type: PropTypes.string,
  noindex: PropTypes.bool,
  jsonLd: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default Seo;
